/**
 * Только маркетинговый сайт услуг (этот репозиторий и деплой на it-24.pro).
 * Интернет-магазин — отдельный продукт и хост; не смешивать SEO, ссылки и GSC.
 */
import type { AppLang } from "@/locale/appLang";
import { pickOfferSite } from "@/locale/content/offerSite";

export const SITE_ORIGIN = "https://it-24.pro";

/** Магазин на поддомене; в UI/схемах маркетинга не используем. */
export const SHOP_ORIGIN = "https://shop.it-24.pro";

/** Query для сброса кэша превью (Telegram и др.) при замене файла в public/. */
export const OG_IMAGE_URL = `${SITE_ORIGIN}/og-image.png?v=20260815c`;

/** Уникальные OG для ключевых страниц (отдельные файлы можно добавить в public/ позже). */
export const PAGE_OG_IMAGES: Partial<Record<string, string>> = {
  "/": OG_IMAGE_URL,
  "/services/incident": `${SITE_ORIGIN}/og-image.png?v=20260815c-incident`,
  "/services/audit": `${SITE_ORIGIN}/og-image.png?v=20260815c-audit`,
  "/services/retainer": `${SITE_ORIGIN}/og-image.png?v=20260815c-retainer`,
  "/services/projects": `${SITE_ORIGIN}/og-image.png?v=20260815c-projects`,
};

export const SEO_BRAND = "IT-24.pro";

/** Ключевые УТП для title/description, Twitter Card и JSON-LD. */
export const SEO_TRUST = {
  slaMinutes: 15,
  yearsExperience: 14,
  projectsCount: 0,
  uptimeTarget: "99.9%",
  foundingYear: 2010,
} as const;

export type SeoMeta = {
  title: string;
  description: string;
  keywords?: string;
};

export type SeoPageKey =
  | "home"
  | "incident"
  | "audit"
  | "retainer"
  | "projects"
  | "cases"
  | "about"
  | "contacts"
  | "kubernetes"
  | "cicd"
  | "ddos"
  | "llmops"
  | "devopsOutsourcing"
  | "serverAdmin"
  | "support247"
  | "vpsHosting"
  | "vacancy"
  | "deleteData";

const SEO_PAGES: Record<SeoPageKey, Partial<Record<AppLang, SeoMeta>>> = {
  home: {
    ru: {
      title: "Инфраструктура для криптовалютного сектора, финтеха и highload | IT-24.pro",
      description:
        "Инженер инфраструктуры: DDoS, PCI DSS, Kubernetes, ноды, vaults. Опыт банков и бирж. Telegram, USDT/инвойс. Retainer от $1 500/мес.",
      keywords:
        "devops криптовалюты, инфраструктура финтех, pci dss, ddos, kubernetes, retainer devops, it-24.pro",
    },
    uk: {
      title: "Інфраструктура для криптовалютного сектору, фінтеху та highload | IT-24.pro",
      description:
        "Інженер інфраструктури: DDoS, PCI DSS, Kubernetes, ноди. Telegram, USDT/інвойс. Retainer від $1 500/міс.",
      keywords: "devops криптовалюти, інфраструктура фінтех, pci dss, ddos, kubernetes, it-24.pro",
    },
    ky: {
      title: "Криптовалюта сектору, финтех жана highload үчүн инфраструктура | IT-24.pro",
      description:
        "DDoS, PCI DSS, Kubernetes, нодалар. Telegram, USDT. Retainer $1 500/айдан.",
      keywords: "devops криптовалюта, финтех, pci dss, ddos, kubernetes, it-24.pro",
    },
  },
  incident: {
    ru: {
      title: "Неотложная помощь по инфраструктуре — инциденты и DDoS | IT-24.pro",
      description: "Восстановление production при атаке или сбое. $100–150/ч. Telegram.",
    },
    uk: {
      title: "Невідкладна інфраструктура | IT-24.pro",
      description: "Підняття проду при атаці. $100–150/год. Telegram.",
    },
  },
  audit: {
    ru: {
      title: "Аудит инфраструктуры и PCI | IT-24.pro",
      description: "Аудит 1–2 дня: безопасность, DDoS, облако, PCI. $300–600.",
    },
  },
  retainer: {
    ru: {
      title: "DevOps retainer для криптовалютного сектора и финтеха | IT-24.pro",
      description: "Абонентское сопровождение $1 500–2 500/мес: релизы, мониторинг, инциденты.",
    },
  },
  projects: {
    ru: {
      title: "PCI DSS, DDoS, Kubernetes — проекты под ключ | IT-24.pro",
      description: "Fixed $3–8k: PCI DSS, DDoS, миграция, Kubernetes, ноды и vaults.",
    },
  },
  cases: {
    ru: {
      title: "Кейсы: банк, биржи, DDoS | IT-24.pro",
      description: "Примеры проектов: PCI DSS, биржи, защита от атак, highload.",
    },
  },
  about: {
    ru: {
      title: "Обо мне — Игорь Косицын | IT-24.pro",
      description: "Инженер инфраструктуры для криптовалютного сектора и финтеха. Польша, PCI DSS, DDoS.",
    },
  },
  contacts: {
    ru: {
      title: "Контакты — Telegram, USDT | IT-24.pro",
      description: "Telegram @devops_it24. USDT, UAH, инвойс PL.",
    },
  },
  kubernetes: {
    ru: {
      title: "Kubernetes под ключ — цена от $3 000, кластер за 2–4 недели | IT-24.pro",
      description:
        "Kubernetes под ключ для бизнеса: развёртывание кластера K8s (EKS/GKE/kubeadm), Helm, GitOps, HPA. Цена проекта $3 000–7 000. Аудит бесплатно — IT-24.pro",
      keywords:
        "kubernetes под ключ, kubernetes цена, настройка kubernetes, развертывание кластера kubernetes, kubernetes consulting, k8s внедрение для компании, GitOps ArgoCD",
    },
    uk: {
      title: "Kubernetes під ключ — ціна від $3 000, кластер за 2–4 тижні | IT-24.pro",
      description:
        "Kubernetes під ключ в Україні: розгортання кластеру K8s, Helm, GitOps, HPA. Ціна $3 000–7 000. Безкоштовний аудит — IT-24.pro",
      keywords:
        "kubernetes під ключ, kubernetes ціна, налаштування kubernetes україна, розгортання кластеру kubernetes, k8s впровадження, GitOps",
    },
    ky: {
      title: "Kubernetes под ключ — $3 000дан, кластер 2–4 жумада | IT-24.pro",
      description:
        "Kubernetes под ключ: K8s кластер (EKS/GKE/kubeadm), Helm, GitOps, HPA. Баа $3 000–7 000. Акысыз аудит — IT-24.pro",
      keywords:
        "kubernetes под ключ, kubernetes орнотуу, k8s кластер, kubernetes setup, GitOps",
    },
  },
  cicd: {
    ru: {
      title: "CI/CD consulting и внедрение — релиз за 15 мин | IT-24.pro",
      description:
        "CI/CD consulting под ключ: GitLab CI / GitHub Actions, zero-downtime, откат одной кнопкой. Внедрение за 2–3 недели от $1 500. Аудит бесплатно.",
      keywords:
        "ci cd consulting, внедрение CI/CD, настройка CI/CD, GitLab CI, GitHub Actions, автоматизация деплоя, zero-downtime deploy",
    },
    uk: {
      title: "CI/CD consulting і впровадження — реліз за 15 хв | IT-24.pro",
      description:
        "CI/CD consulting під ключ: GitLab CI / GitHub Actions, zero-downtime. Впровадження за 2–3 тижні від $1 500. Безкоштовний аудит.",
      keywords: "ci cd consulting, впровадження CI/CD, GitLab CI, GitHub Actions, автоматизація деплою, zero-downtime",
    },
    ky: {
      title: "CI/CD consulting жана киргизүү — 15 мүнөттө релиз | IT-24.pro",
      description:
        "CI/CD consulting: GitLab CI / GitHub Actions, zero-downtime. 2–3 жумада $1 500дан. Акысыз аудит.",
      keywords: "ci cd consulting, CI/CD, GitLab CI, GitHub Actions, zero-downtime, DevOps",
    },
  },
  ddos: {
    ru: {
      title: "Услуги по защите от DDoS — аптайм 99.95% | IT-24.pro",
      description:
        "Услуги по защите от DDoS для B2B: L3–L7, WAF, geo-failover. Сохраняем выручку в атаке. SLA 15 мин, от $2 000. Аудит бесплатно.",
      keywords:
        "услуги по защите от ddos, защита от DDoS, DDoS protection, WAF, Cloudflare, отказоустойчивость, AWS Shield",
    },
    uk: {
      title: "Послуги із захисту від DDoS — аптайм 99.95% | IT-24.pro",
      description:
        "Послуги із захисту від DDoS для B2B: L3–L7, WAF, geo-failover. Зберігаємо виручку під атакою. SLA 15 хв, від $2 000.",
      keywords: "послуги захисту від ddos, захист від DDoS, Cloudflare, WAF, відмовостійкість",
    },
    ky: {
      title: "DDoS коргоо кызматтары — 99.95% аптайм | IT-24.pro",
      description:
        "DDoS коргоо: L3–L7, WAF, geo-failover. SLA 15 мүн, $2 000дан. Акысыз аудит.",
      keywords: "DDoS коргоо, ddos protection, WAF, Cloudflare",
    },
  },
  llmops: {
    ru: {
      title: "LLMOps и приватный AI в Kubernetes под ключ | IT-24.pro",
      description:
        "Private AI в K8s, гибридный llm-router и MCP-агенты: −50–80% к чекам OpenAI/Claude, код не покидает VPC. Fixed Price за 5–10 дней. Аудит бесплатно.",
      keywords:
        "LLMOps, private AI, приватный AI Kubernetes, llm-router, локальная LLM, MCP серверы, оптимизация OpenAI, DevOps агенты",
    },
    uk: {
      title: "LLMOps і приватний AI в Kubernetes під ключ | IT-24.pro",
      description:
        "Private AI у K8s, гібридний llm-router і MCP-агенти: −50–80% до рахунків OpenAI/Claude, код не виходить за VPC. Fixed Price за 5–10 днів.",
      keywords:
        "LLMOps, private AI, приватний AI Kubernetes, llm-router, локальна LLM, MCP сервери, оптимізація OpenAI",
    },
    ky: {
      title: "LLMOps жана жеке AI Kubernetes'tе под ключ | IT-24.pro",
      description:
        "Private AI K8s'те, гибриддик llm-router жана MCP-агенттер: OpenAI/Claude эсебин −50–80%, код VPC'ден чыкпайт. 5–10 күндө Fixed Price.",
      keywords: "LLMOps, private AI, жеке AI Kubernetes, llm-router, локалдык LLM, MCP",
    },
  },
  devopsOutsourcing: {
    ru: {
      title: "DevOps аутсорсинг и IT-аутсорсинг — SLA 15 мин | IT-24.pro",
      description:
        "DevOps аутсорсинг / IT-аутсорсинг: CI/CD, Kubernetes, мониторинг 24/7, FinOps −40%. Пакеты от $1 500/мес вместо штатного Senior. Бесплатный аудит 30 мин.",
      keywords:
        "DevOps аутсорсинг, IT аутсорсинг, devops аутсорсинг, IT-аутсорсинг, kubernetes managed services, CI/CD, сопровождение инфраструктуры",
    },
    uk: {
      title: "ІТ аутсорсінг / DevOps аутсорсинг — SLA 15 хв | IT-24.pro",
      description:
        "ІТ аутсорсінг і DevOps-команда замість штатного інженера: аптайм 99.9%, швидкі релізи, FinOps −40%. Пакети від $1 500/міс. Безкоштовний аудит 30 хв.",
      keywords:
        "іт аутсорсінг, ІТ аутсорсинг, DevOps аутсорсинг, DevOps послуги, kubernetes, CI/CD, супровід інфраструктури",
    },
    ky: {
      title: "DevOps / IT аутсорсинг — SLA 15 мүн | IT-24.pro",
      description:
        "IT жана DevOps аутсорсинг: 99.9% аптайм, тез релиз, FinOps −40%. Пакеттер $1 500/айдан. Акысыз 30 мүн аудит.",
      keywords: "DevOps аутсорсинг, IT аутсорсинг, kubernetes, CI/CD, инфраструктура тейлөө",
    },
  },
  serverAdmin: {
    ru: {
      title: "Администрирование Linux серверов — аутсорсинг 24/7 | IT-24.pro",
      description:
        "Администрирование Linux серверов и линукс-серверов на аутсорсинге: Nginx, MySQL, мониторинг, бэкапы. SLA от 15 мин, от $1 500/мес. Бесплатный аудит.",
      keywords:
        "администрирование linux сервера, администрирование линукс серверов, администрирование серверов, администратор сервера на аутсорсинг, удалённое администрирование Linux",
    },
    uk: {
      title: "Адміністрування Linux серверів — аутсорсинг 24/7 | IT-24.pro",
      description:
        "Адміністрування Linux серверів на аутсорсингу: Nginx, MySQL, моніторинг, бекапи. SLA від 15 хв, від $1 500/міс. Безкоштовний аудит.",
      keywords:
        "адміністрування linux серверів, адміністрування серверів Україна, адміністратор сервера на аутсорсинг",
    },
    ky: {
      title: "Linux серверлерди башкаруу — 24/7 аутсорсинг | IT-24.pro",
      description:
        "Linux сервер администрирование: Nginx, MySQL, мониторинг, бэкап. SLA 15 мүн, $1 500/айдан.",
      keywords:
        "linux сервер башкаруу, серверлерди башкаруу, сервер администратору аутсорсинг",
    },
  },
  support247: {
    ru: {
      title: "Поддержка серверов 24/7 B2B — SLA 15 мин, меньше простоев | IT-24.pro",
      description:
        "Проблема — падение сайта ночью; решение — on-call с SLA 15 мин. Мониторинг, бэкапы. 14 лет опыта. От $300/мес. Аудит стоимости простоя бесплатно.",
      keywords: "поддержка серверов 24/7, мониторинг серверов, on-call DevOps, SLA 15 минут",
    },
    uk: {
      title: "Підтримка серверів 24/7 B2B — SLA 15 хв, менше простоїв | IT-24.pro",
      description:
        "Проблема — падіння сайту вночі; рішення — on-call з SLA 15 хв. Моніторинг, бекапи. 14+ років досвіду. Від $300/міс. Безкоштовний аудит простою.",
      keywords: "підтримка серверів 24/7, моніторинг, on-call DevOps, SLA 15 хвилин",
    },
    ky: {
      title: "Серверлерди колдоо 24/7 B2B — SLA 15 мүн, аз токтолуу | IT-24.pro",
      description:
        "Түнү менен сайт түшсө — on-call SLA 15 мүн. Мониторинг, бэкап. 14+ жыл тажрыйба. $300/айдан. Токтолуу аудити акысыз.",
      keywords: "24/7 сервер колдоо, мониторинг, on-call DevOps, SLA 15 мүн",
    },
  },
  vpsHosting: {
    ru: {
      title: "VPS Hetzner CX23 — аренда от $7.62/мес | IT-24.pro",
      description:
        "VPS хостинг Hetzner: CX23, CPX, NVMe, DDoS. Арендовать VPS сервер от $7.62/мес с SLA 15 мин на русском. Managed VPS, мониторинг и Kubernetes — IT-24.pro.",
      keywords:
        "hetzner vps, hetzner cx23, hetzner cloud cx23, VPS хостинг, арендовать VPS сервер, дешевый VPS Hetzner, VPS для бизнеса, hetzner тарифы",
    },
    uk: {
      title: "VPS Hetzner CX23 Україна — від $7.62/міс | IT-24.pro",
      description:
        "VPS хостинг Україна на Hetzner: CX23, CPX, NVMe, DDoS. Орендувати VPS від $7.62/міс з SLA 15 хв українською. Managed VPS і Kubernetes — IT-24.pro.",
      keywords:
        "hetzner vps, hetzner cx23, VPS хостинг Україна, орендувати VPS сервер, дешевий VPS Hetzner, VPS для бізнесу",
    },
    ky: {
      title: "VPS Hetzner CX23 — $7.62/айдан ижара | IT-24.pro",
      description:
        "VPS хостинг Hetzner: CX23, CPX, NVMe, DDoS. VPS сервер ижара $7.62/айдан, SLA 15 мүн. Managed VPS жана Kubernetes — IT-24.pro.",
      keywords:
        "hetzner vps, hetzner cx23, VPS хостинг, VPS сервер ижара, арзан VPS Hetzner, бизнес үчүн VPS",
    },
  },
  vacancy: {
    ru: {
      title: "Вакансия DevOps: стажировка у команды с SLA 15 мин | IT-24.pro",
      description:
        "Помощник DevOps в IT-24.pro: реальные K8s/CI/CD проекты, менторство, 14 лет практики. Удалённо. Отклик — Telegram.",
      keywords: "вакансия DevOps, помощник DevOps, стажировка DevOps",
    },
    uk: {
      title: "Вакансія DevOps: стажування в команді з SLA 15 хв | IT-24.pro",
      description:
        "Помічник DevOps в IT-24.pro: реальні K8s/CI/CD проєкти, менторство, 14+ років практики. Віддалено, Київ. Відгук — Telegram.",
      keywords: "вакансія DevOps, помічник DevOps, стажування DevOps",
    },
    ky: {
      title: "DevOps вакансиясы: SLA 15 мүн командада стажировка | IT-24.pro",
      description:
        "DevOps жардамчысы IT-24.pro: чыныгы K8s/CI/CD долбоорлор, менторство, 14+ жыл тажрыйба. Аралыктан. Telegram аркылуу.",
      keywords: "DevOps вакансия, DevOps стажировка",
    },
  },
  deleteData: {
    ru: {
      title: "Удаление данных пользователя — IT-24.pro",
      description: "Запрос на удаление персональных данных по GDPR/законодательству. Ответ в течение 30 дней.",
    },
    uk: {
      title: "Видалення даних користувача — IT-24.pro",
      description: "Запит на видалення персональних даних за GDPR. Відповідь протягом 30 днів.",
    },
    ky: {
      title: "Колдонуучу маалыматтарын өчүрүү — IT-24.pro",
      description: "GDPR боюнча жеке маалыматтарды өчүрүү суроosu. 30 күндүн ичинде жооп.",
    },
  },
};

const OFFER_SEO: Partial<Record<SeoPageKey, (lang: AppLang) => SeoMeta>> = {
  home: (lang) => pickOfferSite(lang).seoHome,
  incident: (lang) => pickOfferSite(lang).services.incident.seo,
  audit: (lang) => pickOfferSite(lang).services.audit.seo,
  retainer: (lang) => pickOfferSite(lang).services.retainer.seo,
  projects: (lang) => pickOfferSite(lang).services.projects.seo,
  cases: (lang) => pickOfferSite(lang).casesPage.seo,
  about: (lang) => pickOfferSite(lang).aboutPage.seo,
  contacts: (lang) => pickOfferSite(lang).contactsPage.seo,
};

/** Мета title/description: витрина — из живых бандлов, legacy-страницы — SEO_PAGES. */
export function pickPageSeo(page: SeoPageKey, lang: AppLang): SeoMeta {
  const fromOffer = OFFER_SEO[page];
  if (fromOffer) return fromOffer(lang);
  const bundle = SEO_PAGES[page];
  return bundle[lang] ?? bundle.ru ?? { title: SEO_BRAND, description: SEO_BRAND };
}

/** Поля для контент-бандлов: seoTitle, seoDesc, seoKeywords. */
export function seoFields(page: SeoPageKey, lang: AppLang) {
  const meta = pickPageSeo(page, lang);
  return {
    seoTitle: meta.title,
    seoDesc: meta.description,
    seoKeywords: meta.keywords ?? "",
  };
}

/** Twitter Card badges — сегмент A (не «SLA 15 / 500+»). */
export function trustTwitterMeta(lang: AppLang) {
  const years = `${SEO_TRUST.yearsExperience}+`;
  if (lang === "uk") {
    return { label1: "Фокус", data1: "обмін / фінтех", label2: "Досвід", data2: `${years} років` };
  }
  if (lang === "kk") {
    return { label1: "Фокус", data1: "төлем / финтех", label2: "Тәжірибе", data2: `${years} жыл` };
  }
  if (lang === "uz") {
    return { label1: "Fokus", data1: "ayirboshlash / fintech", label2: "Tajriba", data2: `${years} yil` };
  }
  if (lang === "ky") {
    return { label1: "Фокус", data1: "алмашуу / финтех", label2: "Тажрыйба", data2: `${years} жыл` };
  }
  return {
    label1: "Фокус",
    data1: "криптовалюты / финтех",
    label2: "Опыт",
    data2: `${years} лет`,
  };
}

/**
 * Абсолютный канонический URL (учитывает префикс `/ru` в pathname).
 * Со слэшем (кроме корня) — как CF Pages directory index для SEO-shells.
 */
export function canonicalUrl(pathname: string): string {
  const p = pathname.split("?")[0].split("#")[0];
  const normalized = p.startsWith("/") ? p : `/${p}`;
  const trimmed = normalized.replace(/\/+$/, "") || "/";
  if (trimmed === "/") return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${trimmed}/`;
}
